import { calculateBookingPrice } from '../pages/bookingPrice';

export default function BookingPrice({ property, range, hasPet, onPetChange }) {
  const price = calculateBookingPrice(property, range, hasPet);
  return <div className="booking-price">
    <label className="booking-price__pet"><input type="checkbox" checked={hasPet} onChange={event => onPetChange(event.target.checked)} /><span>Bring a Pet <strong>+${property.petFee}</strong><small>One fee per booking</small></span></label>
    <div aria-live="polite" aria-atomic="true">
      {price ? <>
        <dl className="escape-booking__summary-details">
          <div><dt>Weekday nights ({price.weekdays} × ${property.rates.weekday})</dt><dd>${price.weekdayTotal}</dd></div>
          <div><dt>Weekend nights ({price.weekends} × ${property.rates.weekend})</dt><dd>${price.weekendTotal}</dd></div>
          <div><dt>Stay Total</dt><dd>${price.stayTotal}</dd></div>
          <div><dt>Pet Add-On</dt><dd>{hasPet ? '+' : ''}${price.petFee}</dd></div>
        </dl>
        <div className="escape-booking__total"><span>Total</span><strong>${price.total}</strong></div>
        <p className="escape-booking__fine-print">Estimated stay price before any taxes or other fees. Your host confirms availability and final booking terms.</p>
      </> : <p className="escape-booking__fine-print">{property.rates.weekday == null ? 'Contact your host for rates and a stay quote.' : 'Choose check-in and check-out dates to see your total.'}{hasPet ? ` Pet add-on: +$${property.petFee} per booking.` : ''}</p>}
    </div>
  </div>;
}
